import React, { Component } from "react";
import { Container, Form, Button, Nav, NavItem, NavLink } from "reactstrap";
import "./randomtest.css";
import { library, counter } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { sample } from "lodash"
library.add(faClock);

class Randomtest3_2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 20
    };
  }

 

  render() {
    const { count } = this.state;
    let box = ["/randomtest16","/randomtest16_2"]
    let box2 = ["/randomtest5","/randomtest5_2"]
    return (
      <div>
        <Container className="comming">
          <Form className="boxrandomtest">
            <h1 className="textrandomtest">แบบทดสอบวัดระดับ</h1>
            <h1 className="cdtimer">
              <FontAwesomeIcon icon="clock" /> {count}
            </h1>
            <Form className="Q1">
              <h3 className="textStudy2">
                3. ข้อใดกล่าวถูกต้อง
              </h3>{" "}
              <br></br>
              <Button className="rdTest1" href={sample(box2)}>
                <h5>ก.เวลาในประวัติศาสตร์ทําให้เราสามารถวิเคราะห์เหตุการณ์ต่าง ๆ ได้ล่วงหน้า</h5>
              </Button>
              <br></br>
              <Button className="rdTest1" href={sample(box)}>
                <h5>ข.เวลาในประวัติศาสตร์สามารถทําให้เราวิเคราะห์เหตุการณ์ต่าง ๆ ได้อย่างถูกต้องมากขึ้น</h5>
              </Button>
              <br></br>
              <Button className="rdTest1" href={sample(box2)}>
                <h5>ค.เวลาในประวัติศาสตร์สามารถทําให้เราย้อนกลับไปวางแผนแก้ไขสิ่งที่เกิดขึ้นมาแล้วได้</h5>
              </Button>
            </Form>
            <Button className="rdTestbt1" href="/randomtest5">
              <h5>ข้ามข้อนี้</h5>
            </Button>
            <br></br>
            <h3 className="ranknumberB">1</h3>
            <h3 className="ranknumberB1">2</h3>
            <h3 className="ranknumberW1">3</h3>
            <h3 className="ranknumberW1">4</h3>
            <h3 className="ranknumberW1">5</h3>
          </Form>
        </Container>

        <div className="footer text-footer">
          <p>Surasak Noorurk</p>
          <p> Project 5935512072 Computer Engineering</p>
          <NavLink href="https://surasak783023869.wordpress.com/">
            ช่องทางการติดต่อ
          </NavLink>
        </div>
      </div>
    );
  }

  componentDidMount() {
    const { startCount } = this.props;
    this.setState({
      count: startCount
    });
    this.doIntervalChange();
  }

  componentDidMount() {
    this.myInterval = setInterval(() => {
      this.setState(prevState => {
        const newCount = prevState.count - 1;
        if (newCount == -1) {
          clearInterval(this.myInterval);
          this.props.history.push("/randomtest5");
        }
        return { count: newCount };
      });
    }, 1000);
  }

  componentWillMount() {
    clearInterval(this.myInterval);
  }
}

export default Randomtest3_2;
